import React from "react";
import FormHeader from "../FormHeader";
import FieldTypes from "../FieldTypes";
import FormGRUPreferences from "../FormGRUPreferences";
import FormItens from "../FormItens";
import { GRUValidator } from "../../../helpers/validators/GRUValidator";
import { build } from "../helps/Builder";
import {
  salvarFormulario,
  editarFormulario
} from "../../../view/gru/actions/FormBuilderGRUActions";
import Preview from "../Preview";
import { View, CardList, ButtonFields } from "react-template";

class GRUBuilderContainer extends View {
  constructor(props) {
    super(props);
    this.state = {
      formTitulo: this.props.editable ? "" : "GRU sem Titulo",
      idForm: null
    };

    this.switchPreview = this.switchPreview.bind(this);

    // Preview
    this.form = null;
    this.active = "FORM";
  }

  componentDidMount() {
    this.updateidForm(this.props.editId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.editable &&
      nextProps.formBuilderGRU.titulo.trim().length > 0 &&
      this.state.formTitulo !== nextProps.formBuilderGRU.titulo
    ) {
      this.setState({ formTitulo: nextProps.formBuilderGRU.titulo });
    }
  }

  submeter(finaliza) {
    const id = this.state.idForm;
    const isValid = GRUValidator(
      this.props.formBuilderGRU.itens,
      this.props.formBuilderGRU.titulo,
      this.props.formBuilderGRU.descricao,
      this.props.formBuilderGRU.servicoBoleto,
      this.props.formBuilderGRU.itens[2].valor,
      this.props.formBuilderGRU.itens[3].valor,
      this.notifyError.bind(this)
    );
    if (isValid) {
      const formSchema = build(
        this.props.formBuilderGRU.itens,
        this.props.formBuilderGRU.titulo,
        this.props.formBuilderGRU.descricao
      );
      const data = {
        adminCpf: this.props.auth.username,
        formSchema: JSON.stringify(formSchema),
        formEditavel: JSON.stringify(this.props.formBuilderGRU),
        status: this.props.formBuilderGRU.statusDisponibilidade,
        idServicoBoleto: this.props.formBuilderGRU.servicoBoleto
      };
      if (id !== null) {
        editarFormulario(
          id,
          data,
          res => {
            this.notifySucess("Formulário salvo", "");
            if (finaliza) {
              this.redirect("/admin/gru");
            }
          },
          error => {
            this.notifyError(
              "Erro",
              "Houve um problema ao salvar o formulário"
            );
          }
        );
      } else {
        salvarFormulario(
          data,
          res => {
            this.notifySucess("Formulário salvo", "");
            // função para atualizar o idForm no state
            this.updateidForm(res.data);
            if (finaliza) {
              this.redirect("/admin/gru");
            }
          },
          error => {
            this.notifyError(
              "Erro",
              "Houve um problema ao salvar o formulário"
            );
          }
        );
      }
    }
  }

  switchPreview() {
    this.form = build(
      this.props.formBuilderGRU.itens,
      this.props.formBuilderGRU.titulo,
      this.props.formBuilderGRU.descricao
    );
    this.active = this.active === "FORM" ? "PREVIEW" : "FORM";
    this.forceUpdate();
  }

  updateidForm(idForm = null) {
    this.setState({ idForm: idForm });
  }

  changeTitulo(formTitulo) {
    formTitulo.trim().length > 0
      ? this.setState({ formTitulo })
      : this.setState({ formTitulo: "GRU sem Título" });
  }

  getButtonTools(hidden) {
    const cancelURL = `/admin/gru${
      this.props.editable ? `/${this.state.idForm}` : ""
    }`;
    return (
      <div aria-hidden={hidden}>
        <ButtonFields
          type="button"
          button="fab"
          icon="remove_red_eye"
          mini
          color="transparent"
          onClick={this.switchPreview}
        />
        <ButtonFields
          type="button"
          button="fab"
          icon="save"
          mini
          color="transparent"
          onClick={() => this.submeter(false)}
        />
        <ButtonFields
          content="Finalizar"
          type="button"
          color="green"
          button="flat"
          onClick={() => this.submeter(true)}
        />
        <ButtonFields
          content="Cancelar"
          type="button"
          color="red"
          button="flat"
          to={cancelURL}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.active === "FORM" ? (
          <div id="form-builder-content">
            <CardList
              titulo={this.state.formTitulo}
              form
              tools={this.getButtonTools(true)}
              actions={this.getButtonTools(false)}
              hiddenTools
            >
              <FormHeader
                titulo={this.props.formBuilderGRU.titulo}
                descricao={this.props.formBuilderGRU.descricao}
                actions={this.props.actionsHeader}
                changeTitulo={this.changeTitulo.bind(this)}
              />
              <FormGRUPreferences
                servicoBoleto={this.props.formBuilderGRU.servicoBoleto}
                statusDisponibilidade={
                  this.props.formBuilderGRU.statusDisponibilidade
                }
                tipo={this.props.formBuilderGRU.itens[0].pergunta}
                actions={this.props.actionsPreferences}
              />
              <FormItens
                itens={this.props.formBuilderGRU.itens}
                actions={this.props.actionsItens}
                tipoForm="gru"
              />
            </CardList>

            <FieldTypes
              tipoForm="gru"
              submeter={this.submeter.bind(this)}
              switchPreview={this.switchPreview.bind(this)}
              actions={this.props.actionsFieldTypes}
              isForm={false}
            />

            {
              //<pre>{JSON.stringify(this.props.formBuilderGRU, null, 2) }</pre>
            }
          </div>
        ) : this.active === "PREVIEW" ? (
          <div id="form-builder-content">
            <Preview
              formSchema={this.form}
              fechaPreview={this.switchPreview}
              tipoForm="gru"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default GRUBuilderContainer;



// WEBPACK FOOTER //
// ./src/components/formbuilder/container/GRUBuilderContainer.js